// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recordingNavBar {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background: #1faeff;
    top: 0;
    left: 0;
    width: 100vw;
    height: 75px;
    z-index: 1;
}

.recordingNavBar .titleText.small {
    color: #fff;
    cursor: pointer;
}

.recordingNavBar .searchBar.small {
    border: none;
}

.recordingNavBar .searchButton.small {
    border: 3px solid white;
}

.recordingVerticalLayout {
    align-items: flex-start !important;
    position: relative;
}

@media all and (max-width: 500px) {
    .recordingVerticalLayout {
        width: calc(100vw - 20px);
    }
}

.recordingTagsContainer {
    margin: 5px;
    align-items: center;
}

#Recording {
    position: relative;
    padding-top: 75px;
    height: 100%;
    overflow-x: hidden;
}

#Recording #LeftPanel {
    flex: 1 1;
    padding: 10px 5px 0 10px;
    align-items: flex-start !important;
    position: relative;
}

#Recording #RightPanel {
    flex: 1 1;
    height: 100%;
    padding: 10px 10px 0 5px;
}

#transcript {
    width: 100%;
    flex: 1 1;
    overflow-y: auto;
    margin-bottom: 0 !important;
}

#DropDownContainer {
    position: absolute;
    right: 47px;
    top: 3px;
    padding-bottom: 2px;
    background: #1faeff;
}

#EditButton {
    position: absolute;
    top: 10px;
    right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Magor/EditTranscript/Recording.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,wBAAwB;IACxB,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,SAAO;IACP,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf","sourcesContent":[".recordingNavBar {\n    position: fixed;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    background: #1faeff;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 75px;\n    z-index: 1;\n}\n\n.recordingNavBar .titleText.small {\n    color: #fff;\n    cursor: pointer;\n}\n\n.recordingNavBar .searchBar.small {\n    border: none;\n}\n\n.recordingNavBar .searchButton.small {\n    border: 3px solid white;\n}\n\n.recordingVerticalLayout {\n    align-items: flex-start !important;\n    position: relative;\n}\n\n@media all and (max-width: 500px) {\n    .recordingVerticalLayout {\n        width: calc(100vw - 20px);\n    }\n}\n\n.recordingTagsContainer {\n    margin: 5px;\n    align-items: center;\n}\n\n#Recording {\n    position: relative;\n    padding-top: 75px;\n    height: 100%;\n    overflow-x: hidden;\n}\n\n#Recording #LeftPanel {\n    flex: 1;\n    padding: 10px 5px 0 10px;\n    align-items: flex-start !important;\n    position: relative;\n}\n\n#Recording #RightPanel {\n    flex: 1;\n    height: 100%;\n    padding: 10px 10px 0 5px;\n}\n\n#transcript {\n    width: 100%;\n    flex: 1;\n    overflow-y: auto;\n    margin-bottom: 0 !important;\n}\n\n#DropDownContainer {\n    position: absolute;\n    right: 47px;\n    top: 3px;\n    padding-bottom: 2px;\n    background: #1faeff;\n}\n\n#EditButton {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
